export default __webpack_public_path__ + "static/media/LSP1.5fc57c94.jpeg";